import { render, staticRenderFns } from "./pcform.vue?vue&type=template&id=3f86e854&scoped=true&"
import script from "./pcform.vue?vue&type=script&lang=js&"
export * from "./pcform.vue?vue&type=script&lang=js&"
import style0 from "./pcform.vue?vue&type=style&index=0&id=3f86e854&prod&scoped=true&lang=scss&"
import style1 from "./pcform.vue?vue&type=style&index=1&id=3f86e854&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f86e854",
  null
  
)

export default component.exports